module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><path fill=\"#222A56\" d=\"M0,0v17.008h17.008V0H0z M15.874,15.025l-2.835-2.836V3.968H4.817L1.982,1.133h13.892V15.025z M5.103,5.951 l5.954,5.953H5.103V5.951z M5.951,5.102h5.954v5.955L5.951,5.102z M1.134,1.982l2.834,2.834v8.223h8.223l2.835,2.834H1.134V1.982z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/relationen-loeschen.svg
// module id = 880
// module chunks = 1